import localStorageAvailable from '../utils/localStorageAvailable';
import axios from '../utils/axios';

const getAuthData = async (user) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/system/admin/menus_and_capability`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
        };
        const response = await axios.request(config);
        return response.data?.payload;
    } catch (err) {
        console.log(err);

    }
};

export default getAuthData;
